<ion-text>
	<div class="scrollable note" scrollY="true">
		<ng-content></ng-content>
	</div>
</ion-text>
